import React, { useEffect, useState } from 'react'
import { StepperContextProvider } from '../SurveyFeature/components/SurveyFeatureStepper/useStepper'
import { RenderSections } from '../SurveyFeature/components/RenderSections'
import { UserSelectInstructorsCard, isSelectableParentSection } from '../SurveyFeature/components/UserSelectInstructorsCard'

interface SectionBySectionViewProps {
  initialFetchedSurveys: any
  onSubmit: () => Promise<void>
}

const SectionBySectionView: React.FC<SectionBySectionViewProps> = ({ initialFetchedSurveys, onSubmit }) => {
  const [survey, setSurvey] = useState<any | null>(null)
  const [isUserSelectEnabled, setIsUserSelectEnabled] = useState<boolean>(() =>
    initialFetchedSurveys?.surveySections?.some(
      (section: any) => isSelectableParentSection(section)
    ) ?? false
  )

  useEffect(() => {
    if (initialFetchedSurveys) {
      setSurvey(initialFetchedSurveys)
    }
  }, [])

  return (
    <>
      {isUserSelectEnabled && <UserSelectInstructorsCard survey={survey} setSurvey={setSurvey} setIsUserSelectEnabled={setIsUserSelectEnabled} isStudentExperience={true} />}
        <StepperContextProvider>
      {!isUserSelectEnabled && <RenderSections rawSections={survey?.surveySections ?? []} onSubmit={onSubmit} />}
    </StepperContextProvider>
    </>
  )
}

export default SectionBySectionView
